/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationV2GoalkeeperTeamState
 */
export interface MatchOperationV2GoalkeeperTeamState {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatchOperationV2GoalkeeperTeamState
     */
    designatedParticipantIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2GoalkeeperTeamState
     */
    activeParticipantId?: string | null;
}

/**
 * Check if a given object implements the MatchOperationV2GoalkeeperTeamState interface.
 */
export function instanceOfMatchOperationV2GoalkeeperTeamState(value: object): value is MatchOperationV2GoalkeeperTeamState {
    if (!('designatedParticipantIds' in value) || value['designatedParticipantIds'] === undefined) return false;
    return true;
}

export function MatchOperationV2GoalkeeperTeamStateFromJSON(json: any): MatchOperationV2GoalkeeperTeamState {
    return MatchOperationV2GoalkeeperTeamStateFromJSONTyped(json, false);
}

export function MatchOperationV2GoalkeeperTeamStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2GoalkeeperTeamState {
    if (json == null) {
        return json;
    }
    return {
        
        'designatedParticipantIds': json['designatedParticipantIds'],
        'activeParticipantId': json['activeParticipantId'] == null ? undefined : json['activeParticipantId'],
    };
}

export function MatchOperationV2GoalkeeperTeamStateToJSON(json: any): MatchOperationV2GoalkeeperTeamState {
    return MatchOperationV2GoalkeeperTeamStateToJSONTyped(json, false);
}

export function MatchOperationV2GoalkeeperTeamStateToJSONTyped(value?: MatchOperationV2GoalkeeperTeamState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'designatedParticipantIds': value['designatedParticipantIds'],
        'activeParticipantId': value['activeParticipantId'],
    };
}

